<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="Company Code" :field="'company_code'" />
            </v-col>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="Name" :field="'name'" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.country_id" v-model:form="form" :field-name="'country_id'" :items="countries" :loading="fetchingCountries" label="Country" />
            </v-col>
            <v-col v-show="countryIsMexico" cols="12">
                <Autocomplete v-model:selected-items="form.state_id" v-model:form="form" :field-name="'state_id'" :items="states" :loading="fetchingStates" label="State" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { type IClient } from '@app/purchase/client/models/Client';
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { useClientRepository } from '@app/purchase/client/repositories/useClientRepository';
import { Country } from '@app/location/country/models/Country';
import { useCountryRepository } from '@app/location/country/repositories/useCountryRepository.ts';
import { useStateRepository } from '@app/location/state/repositories/useStateRepository.ts';

const props = defineProps({
    item: {
        type: Object as PropType<IClient>,
        required: true,
    },
});

const update = useClientRepository().command.update(props.item.id, props.item);
const form = update.form;
useInjectSubmitForm(update.execute);

// TODO: refactor and consolidate all usages like this into a CountryCollection model
const countryIsMexico = computed(() => form.country_id === countries.value.find((country) => Country.isMexico(country))?.id);
const { countries, fetchingCountries } = useCountryRepository().query.list();
const { states, fetchingStates } = useStateRepository().query.list();

watch(
    () => form.country_id,
    () => {
        if (!countryIsMexico.value) {
            form.state_id = null;
        }
    },
);
</script>
